import { displayToast, sendAppsignalError } from "../modules/utils";
export default class RegionSelect {
  constructor(node) {
    this.element = node;
    this.selectedCountryInput = this.element.querySelector(".js-select-country-option");
    this.countryDropdown = this.element.querySelector(".js-country-dropdown");
    this.regionDropdown = this.element.querySelector(".js-region-dropdown");
    this.visibleRegionOptionInput = this.element.querySelector(".js-select-visible-region-option");
    this.visibleCountryOptionInput = this.element.querySelector(".js-select-visible-country-option");
    this.regionOptionInput = this.element.querySelector(".js-select-region-option");

    this.fetchUrl = new URL(this.element.dataset.fetchUrl, window.location);

    this.initialize();
  }

  initialize() {
    this.selectedCountryInput.addEventListener("change", (e) => {
      this.fetchRegion(e.target.value);
    });
  }

  setRegion(value, skipError = false) {
    // This only works if the value is the full name of the region
    const radioItem = this.regionDropdown.querySelector(`input[data-full-name="${value}"]`);

    if (!radioItem) {
      const message = `Region not found in dropdown: ${value}`;

      if (!skipError) {
        // We may want to skip the error if we are attempting this with multiple administative_area_levels via google places API
        displayToast(this.element.dataset.errorFetch, "warning");
        sendAppsignalError(message, "RegionSelect", {});
      }

      return false;
    }

    radioItem.checked = true;

    this.visibleRegionOptionInput.innerHTML = value;
    this.visibleRegionOptionInput.dataset.fullName = value;

    this.regionOptionInput.value = radioItem.value;
    this.regionOptionInput.dataset.valueCode = radioItem.dataset.valueCode;

    return true; // So we can check if the region was set successfully
  }

  setCountry(value, skipError = false) {
    value = value.toLowerCase();
    const radioItem = this.countryDropdown.querySelector(`input[data-value-code="${value}"]`);

    if (!radioItem) {
      const message = `Country not found in dropdown: ${value}`;

      if (!skipError) {
        console.error(message);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(message, "RegionSelect", {});
      }
      return false;
    }

    radioItem.checked = true;

    this.visibleCountryOptionInput.innerHTML = radioItem.dataset.fullName;
    this.visibleCountryOptionInput.dataset.fullName = radioItem.dataset.fullName;

    this.selectedCountryInput.value = radioItem.value;
    this.selectedCountryInput.dataset.valueCode = radioItem.dataset.valueCode;

    this.selectedCountryInput.dispatchEvent(new Event("change"));

    return true; // So we can check if the country was set successfully
  }

  fetchRegion(country) {
    this.fetchUrl.searchParams.set(this.selectedCountryInput.name, country);

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Region fetch failed");
      })
      .then((data) => {
        let html = "";

        data.regions.forEach((region, index) => {
          const { id, name, code } = region;
          const checked = index === 0 ? "checked" : "";

          if (index === 0) {
            this.visibleRegionOptionInput.innerHTML = name;
            this.visibleRegionOptionInput.dataset.fullName = name;
            this.regionOptionInput.value = id;
            this.regionOptionInput.dataset.valueCode = code;
          }

          html += `
          <label class="custom-radio" for="${code}">
          <input type="radio" name="region" ${checked} id="${code}" data-value-code="${code}" value="${id}" data-full-name="${name}">
          <div class="select-value js-select-value">${name}</div>
          </label>
          `;
        });

        this.regionDropdown.innerHTML = html;

        window.dispatchEvent(new CustomEvent("region-select-fetch-success", { detail: data.postalCodeRegex }));
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "RegionSelect", {
          response: this.response,
        });
      });
  }
}
